import Loading from "components/Loading";
import {getAuth} from "firebase/auth";
import {useAuthState} from "react-firebase-hooks/auth";
import {useEffect} from "react";
import {useNavigate, useSearchParams} from "react-router-dom";
import {isNullOrUndefined} from "helpers/is-null-or-undefined";
import {useBrandVoice} from "data/access/deliverables/useBrandVoice";
import {useBrandStyles} from "data/access/deliverables/useBrandStyles";


function PaymentCompleted() {
  const navigate = useNavigate();
  const auth = getAuth();
  const [user] = useAuthState(auth);
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("sessionId");

  const [
    generateBrandVoice,
    {
      availableCreditsToUse: availableBrandVoiceCreditsToUse,
      canGenerateNew: canGenerateNewBrandVoice,
    }, brandVoiceDefinitionLoading, brandVoiceDefinitionError] = useBrandVoice();
  const [
    generateBrandStyles,
    {
      availableCreditsToUse: availableBrandStylesCreditsToUse,
      canGenerateNew: canGenerateNewBrandStyles,
    }, brandStylesDefinitionLoading, brandStylesDefinitionError] = useBrandStyles();

  useEffect(() => {
    if (
        isNullOrUndefined(user)
        || isNullOrUndefined(sessionId)
        || brandStylesDefinitionLoading
        || brandVoiceDefinitionLoading
        || brandVoiceDefinitionError !== null
        || brandStylesDefinitionError !== null
    ) {
      return;
    }
    if (
        availableBrandVoiceCreditsToUse === 0
        || availableBrandStylesCreditsToUse === 0
        || !canGenerateNewBrandVoice
        || !canGenerateNewBrandStyles
    ) {
      navigate("/");
      return;
    }
      Promise.all([
        generateBrandVoice(),
        generateBrandStyles(),
      ]).then(() => navigate("/"));
  }, [
    user,
    sessionId,
    availableBrandVoiceCreditsToUse,
    availableBrandStylesCreditsToUse,
    canGenerateNewBrandVoice,
    canGenerateNewBrandStyles,
    brandStylesDefinitionLoading,
    brandVoiceDefinitionLoading,
    brandVoiceDefinitionError,
    brandStylesDefinitionError,
  ]);

  return <div><Loading loadingText={"Processing payment..."}/></div>;
}

export default PaymentCompleted;
